import { createIsbotFromList, isbotPatterns, list, isbot } from 'isbot'

const WHITELIST_USER_AGENTS: string[] = [
  'Mozilla/5.0 (Unknown; Linux x86_64) AppleWebKit/534.34 (KHTML, like Gecko) PingdomTMS/0.8.5 Safari/534.34',
]

function createCustomIsBot(whitelist: string[]): (userAgent: string) => boolean {
  const patternsToRemove = new Set<string>(
    whitelist.map(isbotPatterns).flat(),
  )

  const filteredList = list.filter(
    (record: string): boolean => patternsToRemove.has(record) === false,
  )

  return createIsbotFromList(filteredList)
}

const customIsBot = createCustomIsBot(WHITELIST_USER_AGENTS)

export { customIsBot, createCustomIsBot, isbot as defaultIsBot }
export default customIsBot
